const styles = {
    subHeadText: {
        width: '598px',
        height: '60px',
        fontFamily: 'Silka_Semi_Bold',
        fontWeight: 400,
        fontSize: '12px',
        lineHeight: '150%',
        color: '#27344E',
        flex: 'none',
        order: 1,
        alignSelf: 'stretch',
        flexGrow: 0,
    },
    container: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        marginLeft: '-60px',
    },
    partnerValue: {
        fontFamily: 'Silka_Semi_Bold',
        fontWeight: 600,
        fontSize: '16px',
        lineHeight: '21px',
        color: '#001533',
        marginBottom: '48px',
    },
    partnerLable: {
        fontFamily: 'Silka_Semi_Bold',
        fontWeight: 600,
        fontSize: '14px',
        lineHeight: '21px',
        color: '#8697AB',
    },
    partnerImage: {
        display: 'flex',
        marginTop: '5px',
    },
    partnerName: {
        width: '449px !important',
        marginLeft: '40px',
        marginBottom: '20px',
    },
    partnerField: {
        marginBottom: '20px',
        width: '566px',
    },
    sendUniqueId: {
        fontFamily: 'Silka_Semi_Bold',
        fontWeight: 600,
        fontSize: '14px',
        lineHeight: '21px',
        color: '#3876AA',
        textAlign: 'center',
        textTransform: 'none',
    },
    uniqueIdValue: {
        background: '#F7F8FC',
        border: '1px solid #C3CCD9',
        borderRadius: '16px',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        padding: '12px 16px 13px',
        gap: '16px',
        width: '542px',
        height: '54px',
        marginBottom: '40px',
    },
    editPartner: {
        background: '#3876AA',
        borderRadius: '16px',
        width: '287px',
        margin: '0px 24px',
        fontFamily: 'Silka_Semi_Bold',
        fontWeight: 600,
        fontSize: '14px',
        lineHeight: '21px',
        color: '#FFFFFF',
        textAlign: 'center',
        textTransform: 'none',
    },
};
export default styles;
